
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/michal-dudak-joining",
      function () {
        return require("private-next-pages/blog/michal-dudak-joining.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/michal-dudak-joining"])
      });
    }
  